import { LINK_FIELDS } from './link';
import { MEDIA, mediaField } from './media';

export const SECTION_MARGIN = `
  sectionMargin {
    top
    bottom
  }
`;

export const CONTENT = `
...on Content {
  blockType
  invertBackground
  columns {
    size
    richText
    enableLink
    link ${LINK_FIELDS()}
  }
  hideBlock
  ${SECTION_MARGIN}
}
`;

export const MEDIA_BLOCK = `
...on MediaBlock {
  blockType
  invertBackground
  position
  ${MEDIA}
  hideBlock
  ${SECTION_MARGIN}
}
`;

export const ACCORDION_BLOCK = `
...on Accordion {
  headline_legacy
  accordionHeadline: headline {
    text
    tag
  }
  items {
    title_legacy
    accordionItemTitle: title {
      text
      tag
    }
    content
    id
  }
  twoColumns
  hideBlock
  ${SECTION_MARGIN}
  id
  blockName
  blockType
}
`;

export const APPLICATION_HERO = `
...on ApplicationHero {
  applicationTitle: title
  description
  cost
  time
  additionalInfo
    buttons {
    button {
      type
      newTab
      reference {
        relationTo
        value {
          ... on Page {
            slug
            parentSlug
          }
        }
      }
      url
      videoId
      document {
        url
        filename
        title
      }
      label
      style
    }
    id
  }
  heroImage {
    ${MEDIA}
    appearance
  }
  hideBlock
  ${SECTION_MARGIN}
  id
  blockName
  blockType
}
`;

export const COMPARISON_TABLE = `
... on ComparisonTable {
  headline_legacy
  headline {
    text
    tag
  }
  hideBlock
  ${SECTION_MARGIN}
  id
  blockName
  blockType
  table
}
`;

export const FEATURES_BLOCK = `
... on FeaturesBlock {
  layout
  mobileNoDescription
  features {
    icon
    title_legacy
    title {
      text
      tag
    }
    description
    id
  }
  image {
    ${MEDIA}
    alignment
  }
  hideBlock
  ${SECTION_MARGIN}
  id
  blockName
  blockType
}
`;

export const GALLERY_BLOCK = `
... on GalleryBlock {
  ${mediaField('mainImage')}
  mainImageLabel_legacy
  mainImageLabel {
    text
    tag
  }
  images {
    ${mediaField('image')}
    label_legacy
    label {
      text
      tag
    }
    id
  }
  mirror
  hideBlock
  ${SECTION_MARGIN}
  id
  blockName
  blockType
}
`;

export const KONTACT_BLOCK = `
... on Kontact {
  hideBlock
  ${SECTION_MARGIN}
  id
  blockName
  blockType
  person {
    ... on Person {
      firstName
      lastName
      phone
      email
      mobile
      jobTitle
      ${mediaField('image')}
      ${mediaField('mobileImage')}
    }
  }
}
`;

export const PRODUCTS_BLOCK = `
... on ProdsBlk {
  headline_legacy
  productsHeadline: headline {
    text
    tag
  }
  mediaOnly
  hideBlock
  ${SECTION_MARGIN}
  id
  blockName
  blockType
  products {
    prodType {
      productType {
        ... on ProductType {
          id
          name
          description
          images {
            id
            imageTitle: title
            ${mediaField('image')}
          }
          videos {
            id
            videoTitle: title
            videoId
            description
          }
          features {
            id
            icon
            label
            featureVideoId
          }
        }
      }
      useCustomDescription
      customDescription
      image
      video
      features {
        feature
        id
      }
      btn {
        type
        newTab
        style
        url
        videoId
        document {
          url
          filename
          title
        }
        label
        reference {
          value {
            ... on Page {
              slug
              parentSlug
            }
          }
        }
        hideButton
      }
    }
  }
}
`;

export const MUSTER = `
... on Muster {
  hideBlock
  ${SECTION_MARGIN}
  id
  blockName
  blockType
  title_legacy
  musterTitle: title {
    text
    tag
  }
  description
  videoUrl
  videoAspectWidth
  videoAspectHeight
  ${mediaField('image')}
  imageAlignment
  buttons {
    button {
      videoId
      newTab
      url
      document {
        url
        filename
        title
      }
      label
      musterButtonType: type
      musterButtonStyle: style
      reference {
        value {
          ... on Page {
            slug
            parentSlug
          }
        }
      }
      hideButton
    }
  }
}
`;

export const TEXT_BLOCK = `
... on TextBlock {
  title_legacy
  semanticTitle: title {
    text
    tag
  }
  description
  hideBlock
  ${SECTION_MARGIN}
  id
  blockName
  blockType
}
`;

export const TEXT_GALLERY = `
... on TextGallery {
  title_legacy
  title {
    text
    tag
  }
  description
  reversed
  textBackground
  hideBlock
  ${SECTION_MARGIN}
  id
  blockName
  blockType
  images {
    ${mediaField('image')}
    label_legacy
    label {
      text
      tag
    }
    secondaryLabel_legacy
    secondaryLabel {
      text
      tag
    }
    id
  }
  buttons {
    button {
      videoId
      newTab
      url
      document {
        url
        filename
        title
      }
      label
      textGalleryButtonType: type
      textGalleryButtonStyle: style
      reference {
        value {
          ... on Page {
            slug
            parentSlug
          }
        }
      }
      hideButton
    }
  }
}
`;

export const PRODUCT_HERO = `
... on ProductHero {
  productHeroTitle: title
  description
  hideBlock
  ${SECTION_MARGIN}
  id
  blockName
  blockType
  links {
    icon
    id
  }
  additionalInfo
  heroImage {
    ${mediaField('media')}
    heroImageAppearance: appearance
  }
  buttons {
    button {
      videoId
      newTab
      url
      document {
        url
        filename
        title
      }
      label
      prodHeroBtnType: type
      prodHeroBtnStyle: style
      reference {
        value {
          ... on Page {
            slug
            parentSlug
          }
        }
      }
    }
  }
}
`;

export const BEFORE_AND_AFTER = `
... on BeforeAndAfter {
  ${mediaField('beforeImage')}
  beforeLabel_legacy
  beforeLabel {
    text
    tag
  }
  ${mediaField('afterImage')}
  afterLabel_legacy
  afterLabel {
    text
    tag
  }
  hideBlock
  ${SECTION_MARGIN}
  id
  blockName
  blockType
}
`;

export const PAGE_HERO = `
... on PageHero {
  title_legacy
  semanticTitle: title {
    text
    tag
  }
  description
  hideBlock
  ${SECTION_MARGIN}
  id
  blockName
  blockType
  icons {
    icon
    id
  }
  heroImage {
    ${mediaField('media')}
    heroImageAppearance: appearance
  }
  buttons {
    button {
      videoId
      newTab
      url
      document {
        url
        filename
        title
      }
      label
      type
      style
      reference {
        value {
          ... on Page {
            slug
            parentSlug
          }
        }
      }
      hideButton
    }
  }
}
`;

export const PROJECT_BLOCK = `
... on ProjectBlock {
  hideBlock
  ${SECTION_MARGIN}
  id
  blockName
  blockType
  cost
  time
  additionalInfo
  additionalTimeInfo
  icons {
    icon
    id
  }
}
`;

export const TOPICS_BLOCK = `
... on TopicsBlock {
  hideBlock
  ${SECTION_MARGIN}
  id
  blockName
  blockType
  title_legacy
  title {
    text
    tag
  }
  topics {
    id
    label_legacy
    label {
      text
      tag
    }
    linkType
    newTab
    link {
      slug
      parentSlug
    }
    url
    ${mediaField('image')}
    hideTopic
  }
}
`;

export const VIDEO_BLOCK = `
... on VideoBlock {
  hideBlock
  ${SECTION_MARGIN}
  id
  blockName
  blockType
  video
}
`;

export const TEAM_BLOCK = `
... on Team {
  hideBlock
  ${SECTION_MARGIN}
  id
  blockName
  blockType
  contactHeading_legacy
  contactHeading {
    text
    tag
  }
}
`;

export const HOMEPAGE_HERO = `
... on HomepageHero {
  hideBlock
  ${SECTION_MARGIN}
  id
  blockName
  blockType
  ${MEDIA.replace('media', 'desktopImage')}
  ${MEDIA.replace('media', 'mobileImage')}
  ${MEDIA.replace('media', 'tabletImage')}
  altText
  desktopImageWidth
  clickAction
  linkFields ${LINK_FIELDS()}
  vimeoVideoId
}
`;

export const GALLERY_PAGE = `
... on GalleryPage {
  galleryType
  useCaseTaxonomies {
    id
    label
    hide: hideUseCase
  }
  productTaxonomies {
    id
    label
    hide: hideProduct
  }
  hideFilterBar
  hideSearchBar
  displayStyle
  desktopColumns
  mobileColumns
  hideBlock
  ${SECTION_MARGIN}
  id
  blockName
  blockType
}
`;

export const FORM_BLOCK = `
... on FormBlock {
  id
  introContent
  submitButtonColor
  useSecondaryForm
  secondaryForm {
    id
    formTitle: title
    confirmationMessage
    submitButtonLabel
    confirmationType
    fields {
      ... on Checkbox {
        name
        label
        width
        required
        checkboxDefaultValue: defaultValue
        id
        blockName
        blockType
      }
      ... on Country {
        name
        label
        width
        required
        id
        blockName
        blockType
      }
      ... on Email {
        name
        label
        width
        required
        id
        blockName
        blockType
      }
      ... on Message {
        message
        id
        blockName
        blockType
      }
      ... on Number {
        name
        label
        width
        numberDefaultValue: defaultValue
        required
        id
        blockName
        blockType
      }
      ... on Select {
        name
        label
        width
        selectDefaultValue: defaultValue
        options {
          label
          value
          id
        }
        required
        id
        blockName
        blockType
      }
      ... on State {
        name
        label
        width
        required
        id
        blockName
        blockType
      }
      ... on Text {
        name
        label
        width
        textDefaultValue: defaultValue
        required
        id
        blockName
        blockType
      }
      ... on Textarea {
        name
        label
        width
        textareaDefaultValue: defaultValue
        required
        id
        blockName
        blockType
      }
    }
  }
  hideBlock
  ${SECTION_MARGIN}
  blockName
  blockType
  form {
    id
    primaryFormTitle: title
    confirmationMessage
    submitButtonLabel
    confirmationType
    fields {
      ... on Checkbox {
        name
        label
        width
        required
        checkboxDefaultValue: defaultValue
        id
        blockName
        blockType
      }
      ... on Country {
        name
        label
        width
        required
        id
        blockName
        blockType
      }
      ... on Email {
        name
        label
        width
        required
        id
        blockName
        blockType
      }
      ... on Message {
        message
        id
        blockName
        blockType
      }
      ... on Number {
        name
        label
        width
        numberDefaultValue: defaultValue
        required
        id
        blockName
        blockType
      }
      ... on Select {
        name
        label
        width
        selectDefaultValue: defaultValue
        options {
          label
          value
          id
        }
        required
        id
        blockName
        blockType
      }
      ... on State {
        name
        label
        width
        required
        id
        blockName
        blockType
      }
      ... on Text {
        name
        label
        width
        textDefaultValue: defaultValue
        required
        id
        blockName
        blockType
      }
      ... on Textarea {
        name
        label
        width
        textareaDefaultValue: defaultValue
        required
        id
        blockName
        blockType
      }
    }
  }
}
`;

export const IFRAME_BLOCK = `
... on IframeBlock {
  src
  customDesktopAspectRatio
  desktopAspectRatioWidth
  desktopAspectRatioHeight
  customMobileAspectRatio
  mobileAspectRatioWidth
  mobileAspectRatioHeight
  hideBlock
  ${SECTION_MARGIN}
  id
  blockName
  blockType
}
`;

export const TEXT_IFRAME_BLOCK = `
... on TextIframeBlock {
  title {
    text
    tag
  }
  description
  reversed
  src
  customDesktopAspectRatio
  desktopAspectRatioWidth
  desktopAspectRatioHeight
  customMobileAspectRatio
  mobileAspectRatioWidth
  mobileAspectRatioHeight
  buttons {
    button {
      videoId
      newTab
      url
      document {
        url
        filename
        title
      }
      label
      textIframeButtonType: type
      textIframeButtonStyle: style
      reference {
        value {
          ... on Page {
            slug
            parentSlug
          }
        }
      }
      hideButton
    }
  }
  hideBlock
  ${SECTION_MARGIN}
  id
  blockName
  blockType
}
`;
